<template>
    <div class="layout">
<!--        左侧导航-->
        <LeftMenu class="LeftMenu">
        </LeftMenu>
<!--        右侧内容-->
        <RightContent class="RightContent">
        </RightContent>
    </div>

</template>

<script>
    import LeftMenu from "./LeftMenu";
    import RightContent from "./RightContent";
    export default {
        components:{
            LeftMenu,
            RightContent
        },
        name: "BasePage"
    }
</script>

<style lang="less" scoped>
    .layout{
        .LeftMenu{
            background-color: #304156;
            position: fixed;
            top: 0;
            bottom: 0;
        }
        .RightContent{
            margin-left: 200px;
        }
    }

</style>
